/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { sleep } from 'app/shared/lib/utilities';

@autoinject
export class TestEssText extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////

    public self: this = this;
    public firstName: string = '';
    public middleName: string = '';
    public lastName: string = '';

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    //constructor(...rest: any[]) { super(...rest); }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    public hasChanges(): boolean {
        return false;
    }

    public async submit(): Promise < boolean > {
        try {
            this.state.beginSave();
            await sleep(750);

            return true;
        }
        finally {
            this.state.endSave();
        }
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
